<template>
  <div id="setting-new">
    <!-- 新版设置显示界面 -->
    <div class="left">
      <div
        :class="{ title: true, active: menuActive.title == item.title }"
        v-for="(item, index) in leftMenu"
        :key="index"
        @click="changeMenu(item)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="right">
      <div class="content" v-if="menuActive.flag == 'ather_array'">
        <!-- 其他平台入口 -->
        <div class="item" v-for="(item, index) in terraceList" :key="index">
          <div class="title">
            <span v-if="item.flag"
              >{{ item.name }}
              <i class="el-icon-edit-outline" @click="item.flag = false"></i
            ></span>
            <span v-else>
              <el-input
                v-model="item.name"
                placeholder="请输入内容"
                @blur="item.flag = true"
              ></el-input>
            </span>
          </div>
          <div class="select">
            <el-checkbox v-model="item.isNotice">需要提示</el-checkbox>
            <el-checkbox v-model="item.isShow">开放</el-checkbox>
          </div>
          <div class="upload">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: item.uploadTitle,
              }"
              :before-upload="beforeAvatarUploadForPDF"
              :on-success="
                (response, file, fileList) => {
                  handleAvatarSuccess2(response, file, fileList, item);
                }
              "
              ><el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>
            <div class="value file_val">
              <span @click="showUp(item.path)">{{ item.filename }} </span
              ><span
                class="colse"
                @click="(item.path = ''), (item.filename = '')"
              >
                <i class="el-icon-circle-close"></i
              ></span>
            </div>
          </div>
          <div class="tip">
            <div class="uptop_tip">只能上传pdf文件</div>
          </div>
          <div class="lj">
            <div class="te"><span v-if="item.hasLj">跳转链接:</span></div>
            <div class="ve">
              <el-input
                v-if="item.hasLj"
                v-model="item.entrance"
                :placeholder="'请输入' + item.name + '跳转的地址'"
                clearable
              ></el-input>
            </div>
            <div class="an">
              <el-button
                size="mini"
                type="primary"
                @click="atherArrayMakesure(item)"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="menuActive.flag == 'ather_item'">
        <!-- 报名须知 -->
        <div class="item">
          <div class="title">
            <span v-if="shouldKnow.flag"
              >{{ shouldKnow.name }}
              <i
                class="el-icon-edit-outline"
                @click="shouldKnow.flag = false"
              ></i
            ></span>
            <span v-else>
              <el-input
                v-model="shouldKnow.name"
                placeholder="请输入内容"
                @blur="shouldKnow.flag = true"
              ></el-input>
            </span>
          </div>
          <div class="select">
            <el-checkbox v-model="shouldKnow.isNotice">需要提示</el-checkbox>
          </div>
          <div class="upload">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: shouldKnow.uploadTitle,
              }"
              :before-upload="beforeAvatarUploadForPDF"
              :on-success="
                (response, file, fileList) => {
                  handleAvatarSuccess2(response, file, fileList, shouldKnow);
                }
              "
              ><el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>
            <div class="value file_val">
              <span @click="showUp(shouldKnow.path)"
                >{{ shouldKnow.filename }} </span
              ><span
                class="colse"
                @click="(shouldKnow.path = ''), (shouldKnow.filename = '')"
              >
                <i class="el-icon-circle-close"></i
              ></span>
            </div>
          </div>
          <div class="tip">
            <div class="uptop_tip">只能上传pdf文件</div>
          </div>
          <div class="lj">
            <div class="ve"></div>
            <div class="an">
              <el-button size="mini" type="primary" @click="editShouldKnow()"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="menuActive.flag == 'tip'">
        <!-- 标签页 -->
        <div
          class="li"
          v-for="(item, index) in labelList[menuActive.key]"
          :key="index"
        >
          <div class="te">
            <span v-if="item.flag">{{ item.content }}</span>
            <span v-else>
              <el-input
                v-model="item.content"
                placeholder="请输入内容"
                @blur="editLabel(item)"
              ></el-input>
            </span>
          </div>
          <div class="but">
            <i class="el-icon-edit-outline" @click="item.flag = false"></i>
          </div>
          <div class="but">
            <i class="el-icon-delete" @click="delLabel(item, index)"></i>
          </div>
        </div>
        <div class="li">
          <div class="add" @click="addLabel">新建</div>
        </div>
      </div>
      <div class="content" v-if="menuActive.flag == 'file'">
        <!-- 两个只有文件上传 -->
        <div class="file-item">
          <div class="va">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: menuActive.title,
              }"
              :before-upload="beforeAvatarUploadForFile"
              :on-success="
                (response, file, fileList) => {
                  handleAvatarSuccess1(
                    response,
                    file,
                    fileList,
                    statusCheckPathOrScorePath[menuActive.key],
                    'y'
                  );
                }
              "
              ><el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>
            <div class="value file_val">
              <span
                @click="showUp(statusCheckPathOrScorePath[menuActive.key].path)"
                >{{ statusCheckPathOrScorePath[menuActive.key].name }} </span
              ><span
                class="colse"
                @click="
                  (statusCheckPathOrScorePath[menuActive.key].path = ''),
                    (statusCheckPathOrScorePath[menuActive.key].name = '')
                "
              >
                <i class="el-icon-circle-close"></i
              ></span>
            </div>
          </div>
          <div class="uptop_tip">只能上传 word / excel / pdf 文件</div>
          <div class="lj">
            <div class="ve"></div>
            <div class="an">
              <el-button
                size="mini"
                type="primary"
                @click="editStatusCheckPathOrScorePath()"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="menuActive.flag == 'notice'">
        <!-- 公告通知 -->
        <div class="item">
          <div class="tit">
            <el-input
              v-model="noticeData.notice"
              placeholder="请输入公告通知内容"
              clearable
            ></el-input>
          </div>
          <div class="upload">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: '公告通知',
              }"
              :before-upload="beforeAvatarUploadForPDF"
              :on-success="
                (response, file, fileList) => {
                  handleAvatarSuccess1(
                    response,
                    file,
                    fileList,
                    noticeData.noticeFile,
                    'y'
                  );
                }
              "
              ><el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>
            <div class="value file_val">
              <span @click="showUp(noticeData.noticeFile.path)"
                >{{ noticeData.noticeFile.name }}
              </span>
              <span
                class="colse"
                @click="
                  (noticeData.noticeFile.path = ''),
                    (noticeData.noticeFile.name = '')
                "
              >
                <i class="el-icon-circle-close"></i
              ></span>
            </div>
          </div>
          <div class="tip">
            <div class="uptop_tip">只能上传pdf文件</div>
          </div>
          <div class="lj">
            <div class="ve"></div>
            <div class="an">
              <el-button size="mini" type="primary" @click="editNotice()"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="menuActive.flag == 'fingerpost'">
        <!-- 加分/免试 -->
        <div class="noti">
          <div class="upload">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: menuActive.title,
              }"
              :before-upload="beforeAvatarUploadForFile"
              :on-success="
                (response, file, fileList) => {
                  handleAvatarSuccess1(
                    response,
                    file,
                    fileList,
                    fingerpostData.fingerpostFile,
                    'n'
                  );
                }
              "
              ><el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>
            <div class="value file_val"  style="margin: 0 15px;" v-for="(fileItem,fileIndex) in fingerpostData.fingerpostFile">
              <span @click="showUp(fileItem.path)"
                >{{ fileItem.name }}
              </span>
              <span
                class="colse"
                @click="colseFile(fileIndex)"
              >
                <i class="el-icon-circle-close"></i
              ></span>
            </div>
          </div>
          <div class="tip">
            <div class="uptop_tip">只能上传 word / excel / pdf 文件</div>
          </div>

          <div class="lj">
            <div class="ve"></div>
            <div class="an">
              <el-button size="mini" type="primary" @click="editFingerpost()"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="menuActive.flag == 'apply'">
        <!-- 另外两个界面的入口设置 -->
        <div class="item" v-for="(item, index) in applyData" :key="index">
          <div class="title">
            <span v-if="item.flag"
              >{{ item.name }}
              <i class="el-icon-edit-outline" @click="item.flag = false"></i
            ></span>
            <span v-else>
              <el-input
                v-model="item.name"
                placeholder="请输入内容"
                @blur="item.flag = true"
              ></el-input>
            </span>
          </div>
          <div class="select">
            <el-checkbox v-model="item.isShow">开放</el-checkbox>
          </div>
          <div class="lj">
            <div class="ve"></div>
            <div class="an">
              <el-button
                size="mini"
                type="primary"
                @click="editApplyQuery(item)"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="menuActive.flag == 'query_enroll'">
        <!-- 本科录取查询入口设置 -->
        <div class="item" v-for="(item, index) in queryEnrollData" :key="index">
          <div class="title">
            <span v-if="item.flag"
              >{{ item.name }}
              <i class="el-icon-edit-outline" @click="item.flag = false"></i
            ></span>
            <span v-else>
              <el-input
                v-model="item.name"
                placeholder="请输入内容"
                @blur="item.flag = true"
              ></el-input>
            </span>
          </div>
          <div class="select">
            <el-checkbox v-model="item.isShow">开放</el-checkbox>
          </div>
          <div class="lj">
            <div class="ve"></div>
            <div class="an">
              <el-button
                size="mini"
                type="primary"
                @click="editQueryEnroll(item)"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftMenu: [
        { title: "公告通知", flag: "notice", key: "notice" },
        { title: "报名须知", flag: "ather_item", key: "shouldKnow" },
        { title: "资料提交/查询", flag: "apply", key: "apply" },
        { title: "本科录取查询", flag: "query_enroll", key: "queryEnroll" },
        { title: "其他平台入口", flag: "ather_array", key: "terrace" },
        { title: "报考专业", flag: "tip", key: "profession" },
        { title: "不通过原因", flag: "tip", key: "refuseReason" },
        // { title: "加分（免试）设置", flag: "fingerpost", key: "fingerpost" },
        { title: "查分申请表附件", flag: "file", key: "getScorePath" },
        {
          title: "报名资料设置",
          flag: "fingerpost",
          key: "fingerpost",
        },
      ],
      menuActive: {
        title: "公告通知",
        flag: "notice",
        key: "notice",
      },
      terraceList: [
        //   其他平台入口
        // {
        //   entrance: "", //其他平台跳转的链接
        //   id: "2",
        //   isNotice: true,
        //   isShow: false,
        //   key: "pay",
        //   name: "缴费入口",
        //   flag: true, //标题名称显示或者隐藏
        //   uploadTitle: "其他平台入口", //上传文件的文件夹名称
        //   filename: "", //上传文件的文件名
        //   path: "", //上传文件的文件路径,
        //   hasLj: true,
        // },
        {
          entrance: "",
          id: "3",
          isNotice: true,
          isShow: false,
          key: "admission",
          name: "准考证打印",
          flag: true, //标题名称显示或者隐藏
          uploadTitle: "其他平台入口",
          filename: "", //上传文件的文件名
          path: "",
          hasLj: false,
        },
        {
          entrance: "",
          id: "4",
          isNotice: true,
          isShow: false,
          key: "score",
          name: "分数查询",
          flag: true, //标题名称显示或者隐藏
          uploadTitle: "其他平台入口",
          filename: "", //上传文件的文件名
          path: "",
          hasLj: false,
        },
        {
          entrance: "",
          id: "5",
          isNotice: true,
          isShow: false,
          key: "enroll",
          name: "录取查询",
          flag: true, //标题名称显示或者隐藏
          uploadTitle: "其他平台入口",
          filename: "", //上传文件的文件名
          path: "",
          hasLj: false,
        },
      ],

      headers: {
        token: this.$token,
      },
      action: this.$baseurl + "/uploadFile",

      labelList: {
        refuseReason: [], // 不通过原因
        profession: [], // 报考专业
      },
      shouldKnow: {
        // 报名须知
        entrance: "",
        isNotice: true,
        key: "enroll",
        name: "录取查询",
        flag: true, //标题名称显示或者隐藏
        uploadTitle: "报名须知",
        filename: "", //上传文件的文件名
        path: "",
      },
      statusCheckPathOrScorePath: {
        getScorePath: { name: "", path: "" }, //查分申请表附件
        getStatusCheckPath: { name: "", path: "" }, // 学籍资格审核表附件
      },
      noticeData: {
        notice: "", // 内容
        noticeFile: {
          name: "",
          path: "",
        },
      },
      fingerpostData: {
        fingerpostFile:[ {
          name: "",
          path: "",
        }],
        commonTxt: "", // 非鼓励政策
        withoutTestTxt: "", // 免试文本
        otherScoreTxt: "", // 加分文本
      },
      applyData: [
        {
          key: "apply",
          name: "资料审核提交(开放时间:3月29日8:00-4月8日17:00)",
          isShow: true,
          flag: true,
        },
        {
          key: "query",
          name: "审核状态查询(开放时间:3月29日8:00-4月12日17:00)",
          isShow: true,
          flag: true,
        },
      ],
      queryEnrollData: [
        {
          key: "queryEnroll",
          name: "本科录取查询",
          isShow: true,
          flag: true,
        },
      ],
    };
  },
  methods: {
    /**
     * 上传前PDF判定
     */
    beforeAvatarUploadForPDF(file) {
      // item.uploadTitle = file.name;
      console.log("file", file);
      let isJPG = file.type === "application/pdf";
      if (!isJPG) {
        this.$message.error("上传图片只能是 pdf 格式!");
      }
      return isJPG;
    },
    colseFile(index){
      this.fingerpostData.fingerpostFile.splice(index,1)
    },

    /**
     * 上传前word/excel/PDF判定
     */
    beforeAvatarUploadForFile(file) {
      // item.uploadTitle = file.name;
      console.log("file", file);
      let isJPG =
        file.type === "application/pdf" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      if (!isJPG) {
        this.$message.error("上传文件只能是 word/excel/pdf 格式!");
      }
      return isJPG;
    },
    handleAvatarSuccess1(response, file, fileList, item, flag) {
      if (flag == "y") {
        item.name = response.result.name;
        item.path = response.result.path;
      } else {
        if (item.length == 2) {
          //最多两张
          item.splice(1, 1);
          item.unshift(response.result);
        } else {
          item.push(response.result);
        }
      }

      this.$forceUpdate();
    },
    handleAvatarSuccess2(response, file, fileList, item) {
      item.filename = response.result.name;
      item.path = response.result.path;
      this.$forceUpdate();
    },
    /**
     * 切换左侧菜单
     */
    changeMenu(menu) {
      this.menuActive = JSON.parse(JSON.stringify(menu));
      switch (menu.key) {
        case "refuseReason":
        case "profession":
          this.getLabelList(menu.key);
          break;
        case "terrace":
          //   其他平台入口
          this.getTerrace();
          break;
        case "shouldKnow":
          //   报名须知
          this.getShouldKnow();
          break;
        case "getScorePath":
        case "getStatusCheckPath":
          // 两个附件上传
          this.getStatusCheckPathOrScorePath(menu.key);
          break;
        case "notice":
          //   通知公告
          this.getNotice();
          break;
        case "fingerpost":
          //   加分/免试
          this.getFingerpost();
          break;
        case "apply":
          //   获取另外两个入口信息
          this.getApplyQuery();
          break;
          case "queryEnroll":
            // 本科录取查询
            this.getQueryEnroll()
            break

        default:
          break;
      }
    },
    /**
     * 获取标签
     */
    getLabelList(type) {
      this.$request("post", "/label/getLabelList", { type: type }, (data) => {
        this.labelList[type] = data;
        this.labelList[type].forEach((element) => {
          this.$set(element, "flag", true);
        });
      });
    },
    /**
     * 编辑标签
     */
    editLabel(item) {
      if (item.content == "") {
        this.$message({
          message: "标签不可为空!",
          type: "warning",
        });
        return;
      }
      if (item.id == "") {
        // 添加标签
        let requestData = {
          type: this.menuActive.key,
          content: item.content,
        };
        this.$request("post", "/label/addLabel", requestData, (data) => {
          this.$message({
            message: "添加成功!",
            type: "success",
          });
          this.getLabelList(this.menuActive.key);
        });
      } else {
        // 编辑标签
        this.$request("post", "/label/editLabel", item, (data) => {
          this.$message({
            message: "保存成功!",
            type: "success",
          });
          this.getLabelList(this.menuActive.key);
        });
      }
    },
    /**
     * 新增标签
     * 新增之前做是否有其他未填写的判断
     */
    addLabel() {
      let flag = true;
      this.labelList[this.menuActive.key].forEach((element) => {
        if (element.content == "") {
          flag = false;
        }
      });
      if (!flag) {
        this.$message({
          message: "请先填写标签!",
          type: "warning",
        });
        return;
      }
      let dd = {
        id: "",
        content: "",
        flag: false,
      };
      this.labelList[this.menuActive.key].push(dd);
    },
    /**
     * 删除标签
     */
    delLabel(item, index) {
      if (item.id == "") {
        this.labelList[this.menuActive.key].splice(index, 1);
      } else {
        this.$request("post", "/label/delLabel", { id: item.id }, (data) => {
          this.$message({
            message: "删除成功!",
            type: "success",
          });
          this.getLabelList(this.menuActive.key);
        });
      }
    },
    /**
     * 编辑报名须知
     */
    editShouldKnow() {
      let requestData = {
        name: this.shouldKnow.name,
        isNotice: this.shouldKnow.isNotice,
        notice: {
          name: this.shouldKnow.filename,
          path: this.shouldKnow.path,
        },
      };
      if (
        requestData.isNotice &&
        (requestData.notice.path == null || requestData.notice.path == "")
      ) {
        this.$message({
          message: "请先上传文件再勾选需要提示！",
          type: "error",
        });
        return;
      }
      this.$request(
        "post",
        "/terraceSetting/editShouldKnow",
        requestData,
        (data) => {
          this.$message({
            message: "保存成功!",
            type: "success",
          });
          this.getShouldKnow();
        }
      );
    },
    /**
     * 查看报名须知
     */
    getShouldKnow() {
      this.$request("post", "/terraceSetting/getShouldKnow", null, (data) => {
        this.shouldKnow.name = data.name;
        this.shouldKnow.isNotice = data.isNotice;
        this.shouldKnow.filename = data.notice.name;
        this.shouldKnow.path = data.notice.path;
      });
    },
    /**
     * 获取查分或学籍资格申请表
     */
    getStatusCheckPathOrScorePath(path) {
      this.$request("post", "/" + path, null, (data) => {
        this.statusCheckPathOrScorePath[this.menuActive.key] = data;
      });
    },
    /**
     * 编辑查分或学籍资格申请表
     */
    editStatusCheckPathOrScorePath() {
      let path =
        this.menuActive.key == "getScorePath"
          ? "/editScorePath"
          : "/editStatusCheckPath";
      this.$request(
        "post",
        path,
        this.statusCheckPathOrScorePath[this.menuActive.key],
        (data) => {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.getStatusCheckPathOrScorePath(this.menuActive.key);
        }
      );
    },
    /**
     * 查看公告
     */
    getNotice() {
      this.$request("post", "/getNotice", null, (data) => {
        this.noticeData = data;
      });
    },
    /**
     * 编辑公告
     */
    editNotice() {
      this.$request("post", "/editNotice", this.noticeData, (data) => {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.getNotice();
      });
    },
    /**
     * 其他平台入口确认事件
     */
    atherArrayMakesure(item) {
      let entrance = "1111";
      if (item.key == "pay" || item.key == "admission") {
        entrance = item.entrance;
      }
      let requestData = {
        key: item.key,
        name: item.name,
        entrance: entrance,
        isShow: item.isShow,
        isNotice: item.isNotice,
        notice: {
          name: item.filename,
          path: item.path,
        },
      };
      this.$request(
        "post",
        "/terraceSetting/editTerrace",
        requestData,
        (data) => {
          this.$message({
            message: "设置成功",
            type: "success",
          });
          this.getTerrace();
        }
      );
    },
    /**
     * 获取其他平台入口
     */
    getTerrace() {
      this.$request("post", "/terraceSetting/getTerrace", null, (data) => {
        console.log("查看入口配置", data);
        for (let index = 0; index < this.terraceList.length; index++) {
          const element = this.terraceList[index];
          element.id = data[index].id;
          element.key = data[index].key;
          element.name = data[index].name;
          element.isNotice = data[index].isNotice;
          element.isShow = data[index].isShow;
          element.entrance = data[index].entrance; //其他平台跳转的连接
          element.filename = data[index].notice.name;
          element.path = data[index].notice.path;
        }
      });
    },
    /**
     * 获取加分免试
     */
    getFingerpost() {
      this.$request("post", "/getFingerpost", null, (data) => {
        this.fingerpostData.fingerpostFile = data.fingerpostFile.data;
      });
    },
    /**
     * 编辑加分免试
     */
    editFingerpost() {
      let requestData = {
        fingerpostFile:{
          data:this.fingerpostData.fingerpostFile
        },
        commonTxt: this.fingerpostData.commonTxt,
        withoutTestTxt: this.fingerpostData.withoutTestTxt,
        otherScoreTxt: this.fingerpostData.otherScoreTxt,
      }

      this.$request("post", "/editFingerpost", requestData, (data) => {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.getFingerpost();
      });
    },
    /**
     * 获取另外两个界面的入口设置
     */
    getApplyQuery() {
      this.$request("post", "/terraceSetting/getApplyQuery", null, (data) => {
        this.applyData = data;
        this.applyData.forEach((element) => {
          this.$set(element, "flag", true);
        });
      });
    },
    /**
     * 编辑另外两个界面的入口设置
     */
    editApplyQuery(item) {
      this.$request("post", "/terraceSetting/editApplyQuery", item, (data) => {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.getApplyQuery();
      });
    },
    getQueryEnroll(){
      this.$request("post", "/terraceSetting/getQueryEnroll", null, (data) => {
        this.queryEnrollData = data;
        this.queryEnrollData.forEach((element) => {
          this.$set(element, "flag", true);
        });
      });
    },
    /**
     * 编辑另外两个界面的入口设置
     */
    editQueryEnroll(item) {
      this.$request("post", "/terraceSetting/editQueryEnroll", item, (data) => {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.getQueryEnroll();
      });
    },
    showUp(path) {
      window.open(path);
    },
  },
  mounted() {
    this.getNotice();
  },
};
</script>

<style lang="less" scoped>
#setting-new {
  width: 100%;
  height: 100%;
  display: flex;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  > .left {
    width: 13%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-right: 10px;
    box-sizing: border-box;
    border-right: 1px solid #dadada;
    > .title {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      box-sizing: border-box;
      border-bottom: 1px solid #dadada;
      transition: 0.3s;
      cursor: pointer;
      &:hover {
        color: #0076fc;
        border-color: #0076fc;
      }
      //   font-weight: bold;
    }
    > .active {
      color: #0076fc;
      border-color: #0076fc;
    }
  }
  > .right {
    width: 0;
    flex: 1;
    height: 100%;
    overflow-y: auto;
    padding: 20px;
    box-sizing: border-box;
    > .content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      > .item,
      > .noti {
        width: 100%;
        height: auto;
        min-height: 180px;
        background-color: #f0f0f0;
        margin-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding: 10px;
        box-sizing: border-box;
        > .title {
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-weight: bold;
          i {
            margin-left: 5px;
            cursor: pointer;
            transition: 0.3s;
            &:hover {
              color: #0076fc;
            }
          }
          .el-input {
            width: 550px;
          }
        }
        > .select,
        > .upload {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-top: 5px;
          > .value {
            cursor: pointer;
            margin-left: 8px;
            > span {
              transition: 0.3s;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        > .tip {
          width: 100%;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
        > .lj {
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          > .te {
            width: auto;
            height: 100%;
            padding-left: 10px;
            box-sizing: border-box;
            font-size: 15px;
            display: flex;
            align-items: center;
          }
          > .ve {
            width: 0;
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .el-input {
              width: 550px;
            }
          }
          > .an {
            width: auto;
            height: 100%;
            display: flex;
            align-items: center;
          }
        }
        > .tit,
        > .titar {
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .el-input {
            width: 550px;
          }
          .el-textarea {
            width: 1000px;
          }
        }
        > .titar {
          margin-top: 15px;
          height: auto;
          > .te {
            width: 120px;
            height: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: flex-end;
            margin-right: 8px;
          }
        }
      }
      > .li {
        width: 100%;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 10px;
        box-sizing: border-box;
        background-color: #f0f0f0;
        border-radius: 10px;
        margin-top: 10px;
        > .add {
          color: #0076fc;
          cursor: pointer;
        }
        > .te {
          width: 0;
          flex: 1;
          height: 100%;
          min-height: 45px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .el-input {
            width: 550px;
          }
        }
        > .but {
          margin: 0 10px;
          color: #0076fc;
          cursor: pointer;
        }
      }
      > .file-item {
        width: 100%;
        height: 100px;
        background-color: #f0f0f0;
        margin-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding: 10px;
        box-sizing: border-box;
        align-items: flex-start;
        > .va {
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          > .value {
            cursor: pointer;
            margin-left: 8px;
            > span {
              transition: 0.3s;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        > .lj {
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          > .ve {
            width: 0;
            flex: 1;
          }
          > .an {
            width: auto;
            height: 100%;
            display: flex;
            align-items: center;
          }
        }
      }
      > .noti {
        height: 600px;
      }
    }
  }
  .uptop_tip {
    font-size: 10px;
    margin-top: 3px;
    color: #ff0000;
  }
  .file_val {
    position: relative;
    > .colse {
      position: absolute;
      opacity: 0;
      transition: 0.3s;
    }
    &:hover .colse {
      opacity: 1;
      color: #0076fc;
    }
  }
}
</style>